import { Button, notification, Table } from 'antd';
import { Customer } from '../../core/models/customer';
import { defaultDateFormat } from '../../core/utils/date.utils';
import { deleteCustomer, getCustomers } from '../../core/services/customer.service';
import { DiscardModal } from '../../components/discard-modal/discard-modal';
import { Loading } from '../../components/loading/loading';
import { SvgIcon } from '../../components/svg-icon/svg-icon';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const CustomerPage: React.FC = () => {
	const { t } = useTranslation();
	const [api, contextHolder] = notification.useNotification();

	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [dataSource, setDataSource] = useState<any[]>([]);
	const [openDiscardModal, setOpenDiscardModal] = useState<boolean>(false);
	const [selectedRow, setSelectedRow] = useState<any>();

	useEffect(() => {
		loadCustomers();
	}, []);

	async function loadCustomers() {
		setIsLoading(true);
		const customers: Customer[] = await getCustomers();

		const dataSource: any[] = [];

		customers.forEach((customer) => {
			dataSource.push({
				key: customer.id,
				name: `${customer.firstname} ${customer.lastname}`,
				email: customer.email,
				phone: customer.phoneNumber,
				lastAppointment: customer.lastAppointment ? defaultDateFormat(customer.lastAppointment) : '-',
				totalAppointments: customer.totalAppointments ?? '-',
			});
		});

		setDataSource(dataSource);
		setIsLoading(false);
	}

	const tableColumns = [
		{
			title: t('backEnd.customers.fullName'),
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: t('common.mail'),
			dataIndex: 'email',
			key: 'email',
			render: (text: string) => <a href={`mailto:${text}`}>{text}</a>,
		},
		{
			title: t('common.phoneNumber'),
			dataIndex: 'phone',
			key: 'phone',
			render: (text: string) => (text ? <a href={`tel:${text}`}>{text}</a> : '-'),
		},
		{
			title: t('backEnd.customers.lastAppointment'),
			dataIndex: 'lastAppointment',
			key: 'last-appointment',
		},
		{
			title: t('backEnd.customers.totalAppointments'),
			dataIndex: 'totalAppointments',
			key: 'total-appointments',
		},
		{
			title: '',
			dataIndex: 'a',
			render: (_value: string, record: any) => (
				<Button icon={<SvgIcon name='delete' size={16} />} onClick={() => onClickDelete(record)}>
					{t('common.delete')}
				</Button>
			),
		},
	];

	function onClickDelete(record: any) {
		setSelectedRow(record);
		setOpenDiscardModal(true);
	}

	function onHandleDelete(accept: boolean) {
		setOpenDiscardModal(false);

		if (accept) {
			const index = dataSource.findIndex((data) => data.key === selectedRow.key);
			if (index > -1) {
				dataSource.splice(index, 1);
			}

			deleteCustomer(selectedRow.key);

			api['error']({
				message: t('backEnd.customers.customerDeleted'),
			});
		}
	}

	return (
		<Loading isLoading={isLoading}>
			{contextHolder}
			<DiscardModal open={openDiscardModal} onClose={onHandleDelete} />
			<Table dataSource={dataSource} columns={tableColumns} />
		</Loading>
	);
};
